import { BCDataGrid, findMessage } from '@bimser/components';
import React from 'react';
import { ErrorCodes } from '../../../services/ErrorCodes';
import { getTaleException } from '../../../utilities/helpers';
import GetFolderItems from '../data/GetFolderItems';
import GetRepositories from '../data/GetRepositories';
import GetTrashItems from '../data/GetTrashItems';
import IDMGridRemoteProps from '../entities/IDMGridRemoteProps';

const useDMCustomStore = (
	props: IDMGridRemoteProps,
	columns: Array<BCDataGrid.Entities.IRemoteColumnProps>
) => {
	return React.useMemo(
		() =>
			new BCDataGrid.Components.CustomStore({
				key: 'ID',
				load: async (options: Parameters<BCDataGrid.Components.CustomStore['load']>[0]) => {
					try {
						const loadOptions = BCDataGrid.Helpers.convertLoadOptions(options, columns);

						switch (props.sceneId) {
							case '#Root':
								return await GetRepositories(loadOptions, props.addToStore);
							case '#Trash':
								return await GetTrashItems(loadOptions, props.addToStore);
							default: {
								if (props.filters) {
									loadOptions.filters.push({
										Operator: 1,
										Filters: props.filters
									});
								}

								if (props.sceneSecretKey) {
									return await GetFolderItems(
										loadOptions,
										props.sceneSecretKey,
										props.addToStore
									);
								}

								return { data: [], totalCount: 0 };
							}
						}
					} catch (error) {
						const errorCode: string = getTaleException(
							error?.exception?.data?.exception
						);
						const message = ErrorCodes[errorCode] || findMessage.get('102552');
						throw new Error(message);
					}
				}
			}),
		[props.sceneId]
	);
};

export default useDMCustomStore;
